/**
 * geographies.ts
 * ----------------
 * Azure geography names.
 */

export const Americas = 'Americas';
export const AsiaPacific = 'AsiaPacific';
export const Europe = 'Europe';
export const MiddleEastAndAfrica = 'MiddleEastAndAfrica';
